import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import 'bootstrap/dist/css/bootstrap.css';
import './styles/style.scss';
import VueSignaturePad from 'vue-signature-pad';
import { migrateLocalStorage } from './utils/migrateLocalStorage';
import './boot/alerts';

// Create the Vue 3 app
const app = createApp(App);

// Create Pinia with persistence plugin
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// Use plugins
app.use(pinia);
app.use(router);
app.use(Antd);
app.use(VueSignaturePad);

// Migrate legacy localStorage data to Pinia stores
migrateLocalStorage();

// Mount the app
app.mount('#app')
